import React from "react";

const RadioButton = ({
  id,
  onClick,
  checked,
}) => {

  const handleClick = (e) => {
    e.preventDefault();  // Prevent default form submission behavior
    e.stopPropagation();  // Stop event from bubbling up to the parent form
    onClick();  // Call the onClick passed in as a prop
  };

  return (
    <div
        // key={id}
        // checked={checked}
        // onClick={onClick}
        // aria-label={title}
        className="w-full h-6 shrink-0 flex items-center justify-center"
    >
      <button 
        onClick={handleClick} 
        className={`w-[15px] h-[15px] rounded-full shrink-0 outline-1 border-white outline ${checked ? "bg-primary border outline-primary" : "outline-zinc-300"}`} 
      />
    </div>
  )
}

export default RadioButton;